import { Param } from "src/types";

export const replaceParamsInTitle = (title: string, params: Param[]) => {
  const TEMPLATE_PARAM_REGEX = /\$\{\{ *([A-Za-z0-9_.]+) *\}\}/g;
  return title.replace(TEMPLATE_PARAM_REGEX, (match, parameterName) => {
    const key = parameterName.split(".").pop() || parameterName;
    const param = params.find((p) => p.key === key);
    return param?.default || match;
  });
};
